import React from "react";
import { Link } from "react-router-dom";
import { Search } from "lucide-react";
import { getLocalizedGlossaryLinks } from "@/i18n";
import { Input } from "@/components/ui/input";

export default function GlossaryAutocomplete({ lang = "en" }) {
  const [query, setQuery] = React.useState("");
  const glossaryLinks = React.useMemo(() => getLocalizedGlossaryLinks(lang), [lang]);
  const isHebrew = lang === "he";
  const normalizedQuery = query.trim().toLowerCase();
  const suggestions = normalizedQuery
    ? glossaryLinks
        .filter((term) =>
          term.label.toLowerCase().includes(normalizedQuery) ||
          term.description.toLowerCase().includes(normalizedQuery)
        )
        .slice(0, 8)
    : [];

  return (
    <section className="rounded-3xl border border-border bg-card/90 p-4 shadow-lg shadow-ocean/5 backdrop-blur-xl md:p-6">
      <label htmlFor="glossary-search" className="mb-2 block text-sm font-semibold text-foreground">
        {isHebrew ? "חיפוש מונחים במילון הימי" : "Search nautical glossary terms"}
      </label>
      <div className="relative">
        <Search className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          id="glossary-search"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          placeholder={isHebrew ? "חפשו מונחים כמו עוגן, מצפן, VHF..." : "Search terms like anchor, beam, VHF..."}
          autoComplete="off"
          className="rounded-2xl pl-11"
        />
      </div>

      {suggestions.length > 0 && (
        <div className="mt-3 overflow-hidden rounded-2xl border border-border bg-background">
          {suggestions.map((term) => (
            <Link
              key={term.href}
              to={term.href}
              className="block border-b border-border/60 px-4 py-3 transition-colors last:border-b-0 hover:bg-primary/10"
            >
              <p className="text-sm font-semibold text-foreground">{term.label}</p>
              <p className="mt-1 line-clamp-2 text-xs text-muted-foreground">{term.description}</p>
            </Link>
          ))}
        </div>
      )}
    </section>
  );
}